<template>
  <transition name="grow" mode="out-in" appear>
    <slot />
  </transition>
</template>

<style scoped>
.grow-enter-active,
.grow-leave-active {
  transition: transform 0.3s ease-in-out;
}

.grow-enter-from,
.grow-leave-to {
  transform: scale(0.6);
}
</style>
